import PropTypes from 'prop-types'
import React, { useState, useEffect, useMemo, useRef } from 'react'

import { Button } from '@/components/Button'
import { Form, FormTextField, FormCheckbox } from '@/components/CoForm'
import { Yup as y } from '@/services/yup'
import { Box } from '@material-ui/core'

import {
  StyledDialog,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle,
} from '@/components/Dialog/styles'

import { unmask } from '@/services/masks'
import * as regexp from '@/consts/regexp'
import formatter from '@/services/formatter'

const DriverFormSchema = y.object({
  wem_nome: y.string().required().min(6, 'Informe o nome completo'),
  wem_cpf: y.string().required().trim().min(14, 'Informe o CPF'),
  wem_rg: y.string().optional(), //.trim().min(12, 'Informe o RG'),
  wem_ativo: y.boolean(),
})

export function DriverFormEdit(props) {
  const { current, open, onClose, onSave } = props

  const [isSubmitting, setIsSubmitting] = useState(false)

  const formRef = useRef(null)

  const defaultValues = useMemo(() => {
    return {
      wem_nome: current?.wem_nome || '',
      wem_ativo: current?.wem_ativo ?? true,
      wem_cpf: current?.wem_cpf ? formatter(current.wem_cpf).toCPF() : '',
      wem_rg: current?.wem_rg ? formatter(current.wem_rg).toRG() : '',
    }
  }, [current])

  useEffect(() => {
    if (formRef.current) {
      formRef.current.setData(defaultValues)
    }
  }, [defaultValues])

  async function handleSubmit(data) {
    const { wem_nome, wem_ativo, wem_cpf, wem_rg } = data

    setIsSubmitting(true)

    await onSave({
      wem_nome,
      wem_ativo,
      wem_cpf: unmask(wem_cpf),
      wem_rg: unmask(wem_rg),
    })

    setIsSubmitting(false)
  }

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Form
        onSubmit={handleSubmit}
        formRef={formRef}
        initialData={defaultValues}
        schema={DriverFormSchema}
      >
        {current && (
          <StyledDialogTitle>
            {current.id ? 'Editar motorista' : 'Adicionar motorista'}
          </StyledDialogTitle>
        )}

        {!current && <StyledDialogTitle>...</StyledDialogTitle>}

        <StyledDialogContent>
          <Box mt={2} display="flex" flexDirection="column" gridGap="1rem">
            <FormTextField
              fullWidth
              name="wem_nome"
              label="Nome Completo"
              type="text"
              variant="standard"
              placeholder=""
              required
            />

            <FormTextField
              fullWidth
              name="wem_cpf"
              label="CPF"
              type="text"
              variant="standard"
              placeholder=""
              required
              textMaskProps={{ mask: regexp.cpf.array }}
              inputProps={{
                inputMode: 'numeric',
              }}
            />

            <FormTextField
              fullWidth
              name="wem_rg"
              label="RG"
              type="text"
              variant="standard"
              placeholder=""
              textMaskProps={{ mask: regexp.rg.array }}
              inputProps={{
                inputMode: 'numeric',
              }}
            />

            <Box>
              <FormCheckbox name="wem_ativo" label="Ativo" />
            </Box>
          </Box>
        </StyledDialogContent>

        <StyledDialogActions>
          <Button variant="outlined" color="primary" onClick={onClose}>
            Cancelar
          </Button>

          <Button
            loading={isSubmitting}
            type="submit"
            variant="contained"
            color="primary"
          >
            Salvar
          </Button>
        </StyledDialogActions>
      </Form>
    </StyledDialog>
  )
}

DriverFormEdit.propTypes = {
  current: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
}
